'use client';

import { LegacyIcon, LegacyIconName, usePageLayout } from '@libs/common-next';
import { TextPassage } from '@petsmart-ui/sparky';

import { useDeliveryTreatPoints } from '@app/pdp/hooks';

import './EstimatedTreatPoints.scss';

type EstimatedTreatPointsProps = {
    qty?: number;
    shopId?: number;
};

export default function EstimatedTreatPoints({
    qty = 1,
    shopId,
}: EstimatedTreatPointsProps) {
    const { flags } = usePageLayout();
    const { treatPoints, isLoading } = useDeliveryTreatPoints(qty, shopId);

    return treatPoints && !isLoading ? (
        <div className="product-details__treat-points">
            {flags.loyaltyAccountMenu ? (
                <LegacyIcon
                    name={LegacyIconName.TREATS_NEW}
                    size={24}
                    data-testid="new-treat-icon"
                />
            ) : (
                <LegacyIcon
                    name={LegacyIconName.TREATS}
                    size={24}
                    data-testid="legacy-treat-icon"
                />
            )}
            <TextPassage size="sm">
                <span>Estimated </span>
                {treatPoints || null}
                <span> points earned</span>
            </TextPassage>
        </div>
    ) : (
        <div className="product-details__treat-points" />
    );
}
